/** KEEP_IN_SYNC(weavy/core/src/shared/enums/run-type.enum.ts) */
export enum RunType {
  WorkflowEditor = 'workflowEditor',
  WorkflowExecution = 'workflowExecution',
}
